function Security() {
  return (
    <div className="col-12 col-md-9">
      <div className="card card-bleed shadow-light-lg mb-6">
        <div className="card-header">
          <div className="row align-items-center">
            <div className="col">
              <h4 className="mb-0">Security Pin</h4>
            </div>
            <div className="col-auto">
              <a className="small text-gray-700" href="/dashboard">
                Forgot your security pin?
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label" htmlFor="currentPassword">
              Current Security pin
            </label>
            <input
              className="form-control"
              id="currentPassword"
              type="password"
              disabled
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="newPassword">
              New Security pin
            </label>
            <input
              className="form-control"
              id="newPassword"
              type="password"
              disabled
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="confirmPassword">
              Confirm Security pin
            </label>
            <input
              className="form-control"
              id="confirmPassword"
              type="password"
            />
          </div>

          <div className="row">
            <div className="col-12 col-md-auto">
              <button className="btn w-100 btn-primary" type="submit" disabled>
                Update Security pin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Security;
